// extracted by mini-css-extract-plugin
export default {"f":"FurtherSquare_f__c20CZ","triangle":"FurtherSquare_triangle__f2r0k","wrapper":"FurtherSquare_wrapper__8XNoC"};